import { useTranslation, Trans } from "react-i18next";

import o1 from '../../img/o1.png';
import o2 from '../../img/o2.png';

function OurMission () {

    const { t } = useTranslation();
      
    return(
        <>
            <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
                <div className="flex flex-col xl:flex-row justify-between gap-[40px]">
                    <div className="xl:pt-[60px]">
                        <p className="host-grotesk leading-[1.2] xl:text-[64px] text-[#2A323F] text-[40px]">{t('about.13')}</p>
                        <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[20px] xl:mt-[40px]"><Trans>{t('about.14')}</Trans></p>
                    </div>
                    <img src={o1} alt="" />
                </div>
                <div className="flex flex-col-reverse xl:flex-row gap-[40px] xl:gap-[100px]">
                    <img src={o2} alt="" />
                    <div className="pt-[80px] xl:pt-[115px]">
                        <p className="host-grotesk leading-[1.2] xl:text-[64px] text-[#2A323F] text-[40px]">{t('about.15')}</p>
                        <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[20px] xl:mt-[40px]"><Trans>{t('about.16')}</Trans></p>
                    </div>  
                </div>
            </div>
        </>
    );
}

export default OurMission;